import { Component, Input } from '@angular/core';
import { IRegcheqModel } from 'src/app/models/regcheq/regcheq.model';
import { UtilsService } from 'src/app/shared/services/utils.service';

@Component({
  selector: 'app-regcheq-viewer',
  templateUrl: './regcheq-viewer.component.html',
  styleUrls: ['./regcheq-viewer.component.scss']
})
export class RegcheqViewerComponent {
  @Input() content: IRegcheqModel | any;
  @Input() showHeader = true;

  public informacionBuscada: {ultimaActualizacion: string, nombre: string, tipoPersona: string, pais: string, riesgo: string} | null = null;
  public listadoSanciones: {displayName: string, name: string, class: string, hasButton: boolean}[] | any[] = [];
  public sancionesDetails: {titulo: string, riesgo: string, riesgoClass: string, id: string, tabla: any, tablaBasica: any}[] | any[] = [];

  public today: string = '';
  public rut: string = '';
  displayedColumns: string[] = ['name', 'value']; // tabla basica de detalles
  showContentList: string[] = [];

  constructor(private utilsService: UtilsService) {}

  public riskMapping = this.utilsService.riskMapping;

  ngOnInit(): void {
    this.setInformacionBuscada();
    this.setListadoSanciones();
    this.setRut();
    this.setSancionesDetails();
    this.setToday();
  }

  toUpperCase(value: string): string {
    if(value) {
      return value.toUpperCase();
    }
    return '';
  }

  setInformacionBuscada() {
    this.informacionBuscada = {
      ultimaActualizacion: this.content?.Reporte?.listas?.lastChecked	|| '',
      nombre: this.getNameFromNodes(), // logica de buscar por nodos, luego vendra en un campo
      tipoPersona: this.toUpperCase(this.content?.Reporte?.personType || '') == 'NATURAL' ? 'Persona Natural' : 
        (this.toUpperCase(this.content?.Reporte?.personType || '') == 'JURIDICA' ? 'Persona Juridica' : ''),
      pais: this.content?.Reporte?.dniType?.country || '',
      riesgo: this.content?.Reporte?.calculatedRisk || ''
    }
  }

  getNameFromNodes(): string {
    let name = '';
    const nodes = ['keywordsResult', 'gafiResult', 'pepChile', 'funcPublicChile', 'pdiResult', 'rtpResult', 'internList', 'regcheqList', 'secondCriminalCasesChile', 'internationalOrganizations']
    if(this.content?.Reporte?.listas && Object.keys(this.content?.Reporte?.listas).length > 0) {
      for (let i = 0; i < nodes.length; i++) {
        const node = nodes[i];
        const nodo = this.content?.Reporte?.listas?.[node];
        if(nodo && Object.keys(nodo).length > 0) {
          if(nodo?.info?.name) {
            name = nodo?.info?.name;
            break;
          } else if(nodo?.data?.additionalData?.name) {
            name = nodo?.data?.additionalData?.name;
            break;
          } else if(nodo?.data?.info?.name) {
            name = nodo?.data?.info?.name;
            break;
          }
        }
      }
    }
    return name;
  }

  setRut() {
    this.rut = this.content?.DatosBasicosSolicitud?.Rut + '-' + this.content?.DatosBasicosSolicitud?.DV
  }

  setToday() {
    this.today = `${new Date().getFullYear()}${(new Date().getMonth() + 1 < 10?  '0'+(new Date().getMonth() + 1) : 
      new Date().getMonth() + 1)}${new Date().getDate()}`;        
  }

  getRiskClass(riesgo: any): string {
    if(this.toUpperCase(riesgo) === 'LOW RISK') {
      return 'chip-low-risk';
    } else if(this.toUpperCase(riesgo) === 'MEDIUM RISK') {
      return 'chip-medium-risk';
    }
    else if(this.toUpperCase(riesgo) === 'HIGH RISK') {
      return 'chip-high-risk';
    }
    return '';
  }

  getRiskClassCircle(riesgo: any): string {
    if(this.toUpperCase(riesgo) === 'LOW') {
      return 'verde';
    } else if(this.toUpperCase(riesgo) === 'MEDIUM') {
      return 'amarillo';
    }
    else if(this.toUpperCase(riesgo) === 'HIGH') {
      return 'rojo';
    }
    return '';
  }


  setListadoSanciones() {
    if(this.content?.Reporte?.listas && Object.keys(this.content?.Reporte?.listas).length > 0) {
      const nodes = [
        { name: 'internList', displayName: 'Lista de Interés'},
        { name: 'keywordsResult', displayName: 'Palabras Claves'},
        { name: 'gafiResult', displayName: 'Países sancionados por GAFI'},
        { name: 'regcheqList', displayName: 'Lista RegCheq'},
        { name: 'pepChile', displayName: 'Persona expuesta políticamente (PEP) Chile'},
        { name: 'funcPublicChile', displayName: 'Funcionarios Públicos Chile'},
        { name: 'pdiResult', displayName: 'Policía de Investigaciones Chile'},
        { name: 'rtpResult', displayName: 'Países con régimen fiscal prefencial'},
        { name: 'internationalOrganizations',displayName: 'Organismos internacionales'},
        { name: 'secondCriminalCasesChile', displayName: 'Causas penales Chile'},
      ]
      const listas = this.content?.Reporte?.listas;
      for (const nodo of nodes) {
        if(listas?.[nodo.name] && Object.keys(listas?.[nodo.name]).length > 0) {
          this.listadoSanciones.push({
            displayName: nodo.displayName,
            name: nodo.name,
            class: this.getRiskClassCircle(listas?.[nodo.name]?.coincidence == true ? listas?.[nodo.name]?.risk : 'low'),
            hasButton: listas?.[nodo.name]?.coincidence == true ?
              (listas?.[nodo.name]?.risk ? (this.toUpperCase(listas?.[nodo.name]?.risk) === 'LOW' ? false : true) : false) :
              false
          });
        }
      }
    }
  }

  setSancionesDetails() {
    if(this.content?.Reporte?.listas && Object.keys(this.content?.Reporte?.listas).length > 0) {
      const nodes = [
        { name: 'internList', displayName: 'Lista de Interés'},
        { name: 'keywordsResult', displayName: 'Palabras Claves'},
        { name: 'gafiResult', displayName: 'Países sancionados por GAFI'},
        { name: 'regcheqList', displayName: 'Lista RegCheq'},
        { name: 'pepChile', displayName: 'Persona expuesta políticamente (PEP) Chile'},
        { name: 'funcPublicChile', displayName: 'Funcionarios Públicos Chile'},
        { name: 'pdiResult', displayName: 'Policía de Investigaciones Chile'},
        { name: 'rtpResult', displayName: 'Países con régimen fiscal prefencial'},
        { name: 'internationalOrganizations',displayName: 'Organismos internacionales'},
        { name: 'secondCriminalCasesChile', displayName: 'Causas penales Chile'},
      ];
      const listas = this.content?.Reporte?.listas;
      for (const nodo of nodes) {
        if(listas?.[nodo.name] && Object.keys(listas?.[nodo.name]).length > 0) {
          const { risk, info, data, coincidence } = listas?.[nodo.name];
          if(coincidence == true && (this.toUpperCase(risk) == 'HIGH' || this.toUpperCase(risk) == 'MEDIUM')) {
            const { name, rut, dni } = info || data?.info || data?.data || data?.additionalData || {};
            const { content, titleTable, displayColumns } = this.getTableDetails(nodo.name);
            this.sancionesDetails.push({
              titulo: nodo.displayName,
              tablaBasica: [
                {
                  name: 'Nombre',
                  value: name || this.getNameFromNodes() || ''
                },
                {
                  name: 'Rut',
                  value: rut || dni || this.rut || ''
                }
              ],
              riesgo: this.riskMapping(risk),
              riesgoClass: this.getRiskClassCircle(risk),
              id: nodo.name,
              tabla: {
                content: content,
                titleTable: titleTable,
                displayColumns: displayColumns
              }
            });

          }
        }
      }
    }

  }
  
  getTableDetails(name: string): { content: any[], titleTable: string[], displayColumns: string[] } | any {
    if(name === 'funcPublicChile') {
      const data = this.content?.Reporte?.listas?.funcPublicChile;
      const motive = data?.info?.motive || '';

      let organismo = '';
      let cargo = '';
      let ingresos = '';
      let fechaTermino = '';

      if(motive) {
        organismo = motive.match(/Organismo:\s*([^;]+)/i)?.[1]?.trim() || '';
        cargo = motive.match(/Cargo:\s*([^;]+)/i)?.[1]?.trim() || '';
        ingresos = motive.match(/Ingreso bruto mensual:\s*([^;]+)/i)?.[1]?.trim() || '';
        fechaTermino = motive.match(/Fecha termino:\s*([^;]+)/i)?.[1]?.trim() || '';
      }

      const contentElement =  {
        organismo: organismo || '',
        cargo: cargo || '',
        ingresos: ingresos || '',
        fechaTermino: fechaTermino || '',
        riesgo: this.riskMapping(data?.risk) || ''
      }
      const content = [contentElement]
      return {
        content: content,
        titleTable: ['Organismo', 'Cargo', 'Ingresos', 'Fecha termino', 'Riesgo'],
        displayColumns: ['organismo', 'cargo', 'ingresos', 'fechaTermino', 'riesgo']
      }
    } else if(name === 'pepChile') {
      const data = this.content?.Reporte?.listas?.pepChile;
      const contentElement =  {
        level: data?.info?.level || data?.data?.info?.level || '',
        position: data?.info?.position || data?.data?.info?.position || '',
        riesgo: this.riskMapping(data?.risk) || ''
      }
      const content = [contentElement]
      return {
        content: content,
        titleTable: ['Nivel', 'Posición', 'Riesgo'],
        displayColumns: ['level', 'position', 'riesgo']
      }
    } else if(name === 'pdiResult') {
      const data = this.content?.Reporte?.listas?.pdiResult;
      const contentElement =  {
        profugoPdi: data?.coincidence == true || data?.coincidence == false ? 
          (data?.coincidence ? 'Si' : 'No') : '',
        riesgo: this.riskMapping(data?.risk) || ''
      }
      const content = [contentElement]
      return {
        content: content,
        titleTable: ['Prófugo PDI', 'Riesgo'],
        displayColumns: ['profugoPdi', 'riesgo']
      }
    } else if(name === 'secondCriminalCasesChile') {
      const data = this.content?.Reporte?.listas?.secondCriminalCasesChile;
      const content = data?.data?.additionalData && data?.data?.additionalData.length > 0 ?
        (data?.data?.additionalData.map((e: any) => {
          return {
            rit: e?.rit || '',
            tribunal: e?.tribunal || '',
            ruc: e?.ruc || '',
            crimen: e?.crimen || '',
            fecha: e?.fecha || '',
            estado: e?.estado || '',
            riesgo: this.riskMapping(e?.riesgo) || ''
          }}
        )) : [];
      return {
        content: content,
        titleTable: ['RIT', 'Tribunal', 'RUC', 'Delito', 'Fecha', 'Estado', 'Riesgo'],
        displayColumns: ['rit', 'tribunal', 'ruc', 'crimen', 'fecha', 'estado', 'riesgo']
      }
    } else if(name === 'internList') {
      const data = this.content?.Reporte?.listas?.internList;
      const contentElement =  {
        razon: data?.info?.reason || '',
        riesgo: this.riskMapping(data?.risk) || ''
      }
      const content = [contentElement]
      return {
        content: content,
        titleTable: ['Razón', 'Riesgo'],
        displayColumns: ['razon', 'riesgo']
      }
    } else if(name === 'gafiResult') {
      const data = this.content?.Reporte?.listas?.gafiResult;
      const contentElement =  {
        nacionalidad: data?.info?.nationality || '',
        residencia: data?.info?.country || '',
        razon: data?.info?.reason || '',
        riesgo: this.riskMapping(data?.risk) || ''
      }
      const content = [contentElement]
      return {
        content: content,
        titleTable: ['Nacionalidad', 'Residencia', 'Razón', 'Riesgo'],
        displayColumns: ['nacionalidad', 'residencia', 'razon', 'riesgo']
      }
    } else if(name === 'keywordsResult') {
      const data = this.content?.Reporte?.listas?.keywordsResult;
      const contentElement =  {
        palabra: data?.info?.word || '',
        riesgo: this.riskMapping(data?.risk) || ''
      }
      const content = [contentElement]
      return {
        content: content,
        titleTable: ['Palabra', 'Riesgo'],
        displayColumns: ['palabra', 'riesgo']
      }
    } else if(name === 'regcheqList') {
      const data = this.content?.Reporte?.listas?.regcheqList;
      const contentElement =  {
        motivo: data?.info?.motive || '',
        riesgo: this.riskMapping(data?.risk) || ''
      }
      const content = [contentElement]
      return {
        content: content,
        titleTable: ['Motivo', 'Riesgo'],
        displayColumns: ['motivo', 'riesgo']
      }
    } else if(name === 'rtpResult') {
      const data = this.content?.Reporte?.listas?.rtpResult;
      const contentElement =  {
        pais: data?.info?.nationality || '',
        riesgo: this.riskMapping(data?.risk) || ''
      }
      const content = [contentElement]
      return {
        content: content,
        titleTable: ['País', 'Riesgo'],
        displayColumns: ['pais', 'riesgo']
      }
    } else if(name === 'internationalOrganizations') {
      const data = this.content?.Reporte?.listas?.internationalOrganizations;
      const typesMatches = data?.info?.typesMatches || [];
      const typesMatchesString = typesMatches.length > 0 ? typesMatches.join(', ') : '';
      const contentElement =  {
        match: data?.info?.total_matches || '',
        tipo: typesMatchesString || '',
        riesgo: this.riskMapping(data?.risk) || ''
      }
      const content = [contentElement]
      return {
        content: content,
        titleTable: ['Match', 'Tipo', 'Riesgo'],
        displayColumns: ['match', 'tipo', 'riesgo']
      }
    } else {
      return {
        content: [],
        titleTable: [],
        displayColumns: []
      };
    }
  }

  addContentShow(id: string): void {
    if(this.showContentList.includes(id)) {
      this.showContentList = this.showContentList.filter((e: string) => e !== id);
      return;
    } else {
      this.showContentList.push(id);
      this.scrollToId(id);
    }
  }

  showAllSanciones() {
    if(this.showContentList.length > 0 && this.showContentList.length == this.sancionesDetails.length) { // si ya se mostraron todos, entonces ocultar
      this.showContentList = [];
    } else {
      this.showContentList = [];
      for (const element of this.sancionesDetails) {
        if(element) {
          this.showContentList.push(element.id);
        }
      }
    }
  }

  scrollToId(id: string): void {
    if(id) {
      // esperar un segundo antes de hacer scroll
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        } else {
          console.error(`Element with id ${id} not found`);
        }
      }, 1000);
    }
  }

  validateAllDetailsShow(): boolean {
    if(this.showContentList.length > 0 && this.showContentList.length == this.sancionesDetails.length) {
      return true;
    } else {
      return false;
    }
  }

  validateContentShow(id: string): boolean {
    if(this.showContentList && this.showContentList.length > 0) {
      const element = this.showContentList.find((e: string) => e === id);
      if(element) {
        return true;
      }
    }
    return false;
  }

}
